var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.005 4C10.0525 4 8.46968 5.58283 8.46968 7.53535C8.46968 9.48788 10.0525 11.0707 12.005 11.0707C13.9576 11.0707 15.5404 9.48788 15.5404 7.53535C15.5404 5.58283 13.9576 4 12.005 4ZM10.6601 12.6078C7.49505 12.6078 4.93433 15.1686 4.93433 18.3336C4.93433 18.8217 5.33003 19.2174 5.81816 19.2174H18.2688C18.7569 19.2174 19.1526 18.8217 19.1526 18.3336C19.1526 15.1686 16.5919 12.6078 13.4269 12.6078H10.6601Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidUser);
export default __webpack_public_path__ + "static/media/solid-user.8797c3c9a17ddb98fbf7997eec894225.svg";
export { ForwardRef as ReactComponent };